import { IsNotEmpty, IsString } from 'class-validator';

export class ChallengeDeviceVerifyRequestDto {
    @IsNotEmpty()
    @IsString()
    code: string;
}
